module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('steps', {
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "switchStep": _vm.switchStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchStep.apply(null, arguments)
      },
      "input": function($event) {
        return _vm.productAcivateUpdateFlag('salesChannels')
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center border-bottom-light my-4 p-4"
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "color-1"
  }, [_vm._v("\n                            This product is currently inactive. To make changes, please activate it first.\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-group d-flex ml-auto"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Sales channel configurations")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', {
    staticClass: "fs-small dark"
  }, [_c('th', {
    staticClass: "niceColumn colHead",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("\n                                                Open\n                                                "), _c('div', {
    staticClass: "mt-1 d-flex flex-row justify-content-center"
  }, [_c('span', {
    staticClass: "hoverLink",
    class: {
      notAllowed: _vm.isReadOnly,
      disabled: _vm.isReadOnly
    },
    on: {
      "click": function($event) {
        !_vm.isReadOnly && _vm.selectAll(true)
      }
    }
  }, [_vm._v("\n                                                        All\n                                                    ")]), _vm._v(" "), _c('span', {
    staticClass: "mx-1"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "hoverLink",
    class: {
      notAllowed: _vm.isReadOnly,
      disabled: _vm.isReadOnly
    },
    on: {
      "click": function($event) {
        !_vm.isReadOnly && _vm.selectAll(false)
      }
    }
  }, [_vm._v("\n                                                    None\n                                                    ")])])]), _vm._v(" "), _c('th', {
    staticClass: "pl-3",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Channel")]), _vm._v(" "), _c('th', {
    staticClass: "niceColumn colHead",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Channel Price Increase")]), _vm._v(" "), _c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', {
    staticClass: "niceColumn colHead",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Commissions")]), _vm._v(" "), _c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', {
    staticClass: "niceColumn colHead",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Manual Confirmation")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.sortedSalesChannels), function(salesChannel, index) {
    return _c('tr', {
      key: salesChannel.id,
      class: [!_vm.isReadOnly ? 'hoverOk' : '', salesChannel.isActive ? 'active' : 'notActive', salesChannel.channelType == 50 ? 'alignTop' : '', 'pointer', {
        notAllowed: _vm.isReadOnly
      }]
    }, [_c('td', {
      staticClass: "niceColumn colContent text-center"
    }, [_c('checkbox', {
      staticClass: "my-2",
      class: {
        'notAllowed': _vm.isReadOnly
      },
      attrs: {
        "disabled": _vm.isReadOnly
      },
      on: {
        "input": function($event) {
          return _vm.salesChannelStateChanged(salesChannel)
        }
      },
      model: {
        value: (salesChannel.isActive),
        callback: function($$v) {
          _vm.$set(salesChannel, "isActive", $$v)
        },
        expression: "salesChannel.isActive"
      }
    })], 1), _vm._v(" "), _c('td', {
      class: {
        'alignTop': salesChannel.channelType == 50
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('div', {
      staticClass: "d-flex flex-row align-items-center pl-3"
    }, [_vm._v("\n                                                            " + _vm._s(salesChannel.channelName) + "\n                                                        "), _vm._v(" "), (salesChannel.channelType == 50) ? _c('div', {
      staticClass: "ml-4"
    }, [_c('v-select', {
      attrs: {
        "options": _vm.agentsChannelOptions,
        "disabled": _vm.isReadOnly || !salesChannel.isActive
      },
      on: {
        "input": function($event) {
          return _vm.agentsChannelOptionsChanged($event, salesChannel)
        }
      },
      model: {
        value: (_vm.selectedAgentsChannelOptions),
        callback: function($$v) {
          _vm.selectedAgentsChannelOptions = $$v
        },
        expression: "selectedAgentsChannelOptions"
      }
    })], 1) : _vm._e()]), _vm._v(" "), (salesChannel.channelType == 50 && _vm.form.salesPermissionsAgentsCustom) ? _c('div', {
      staticClass: "px-3 py-2 bg-lightest d-flex flex-column my-2"
    }, [_c('agent-white-list', {
      staticClass: "mt-2",
      staticStyle: {
        "width": "50%",
        "min-width": "250px"
      },
      attrs: {
        "allowedList": _vm.form.salesPermissionsAgentsList,
        "blockedList": _vm.form.salesBlockedAgentList,
        "startAllSelected": _vm.customAgentListSelectAll
      },
      on: {
        "input": _vm.agentListChanged
      }
    })], 1) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "niceColumn colContent text-center"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      staticClass: "glued-right",
      staticStyle: {
        "width": "3rem"
      },
      attrs: {
        "type": "number",
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.getMultiplier(salesChannel.channelId)
      },
      on: {
        "input": function (event) { return _vm.setMultiplier(salesChannel.channelId, event.target.value); }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "glued-left",
      class: {
        'disabled-channel-price': _vm.isReadOnly
      }
    }, [_vm._v("%")])])]), _vm._v(" "), _c('td', [_vm._v("\n                                                 \n                                            ")]), _vm._v(" "), _c('td', {
      staticClass: "niceColumn colContent"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (salesChannel.productAmountValue),
        expression: "salesChannel.productAmountValue"
      }],
      staticClass: "glued-right mr-0 pr-0 vselect-compact",
      attrs: {
        "type": "number",
        "disabled": _vm.isReadOnly || !salesChannel.isActive
      },
      domProps: {
        "value": (salesChannel.productAmountValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(salesChannel, "productAmountValue", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('v-select', {
      staticClass: "glued-left vselect-compact",
      attrs: {
        "options": _vm.getPercentageOrCurrency,
        "disabled": _vm.isReadOnly || !salesChannel.isActive
      },
      on: {
        "input": function($event) {
          return _vm.commissionTypeChanged(salesChannel, index, 'productAmountType')
        }
      },
      model: {
        value: (salesChannel.productAmountType_helper_selected),
        callback: function($$v) {
          _vm.$set(salesChannel, "productAmountType_helper_selected", $$v)
        },
        expression: "salesChannel.productAmountType_helper_selected"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "niceColumn colContent"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (salesChannel.componentAmountValue),
        expression: "salesChannel.componentAmountValue"
      }],
      staticClass: "glued-right mr-0 pr-0 vselect-compact",
      attrs: {
        "type": "number",
        "disabled": _vm.isReadOnly || !salesChannel.isActive
      },
      domProps: {
        "value": (salesChannel.componentAmountValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(salesChannel, "componentAmountValue", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('v-select', {
      staticClass: "glued-left vselect-compact",
      attrs: {
        "options": _vm.getPercentageOrCurrency,
        "disabled": _vm.isReadOnly || !salesChannel.isActive
      },
      on: {
        "input": function($event) {
          return _vm.commissionTypeChanged(salesChannel, index, 'componentAmountType')
        }
      },
      model: {
        value: (salesChannel.componentAmountType_helper_selected),
        callback: function($$v) {
          _vm.$set(salesChannel, "componentAmountType_helper_selected", $$v)
        },
        expression: "salesChannel.componentAmountType_helper_selected"
      }
    })], 1)]), _vm._v(" "), _c('td', [_vm._v("\n                                                 \n                                            ")]), _vm._v(" "), _c('td', {
      staticClass: "niceColumn colContent text-center"
    }, [(_vm.canThisChannelHaveManualConfirmation(salesChannel)) ? [_c('checkbox', {
      staticClass: "my-2",
      attrs: {
        "disabled": _vm.isReadOnly || !salesChannel.isActive
      },
      model: {
        value: (salesChannel.isManualConfirmation),
        callback: function($$v) {
          _vm.$set(salesChannel, "isManualConfirmation", $$v)
        },
        expression: "salesChannel.isManualConfirmation"
      }
    })] : [_c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ('This sales channel cannot have manual confirmation'),
        expression: "'This sales channel cannot have manual confirmation'"
      }],
      staticClass: "fas fa-info-circle fs-large dark mr-1"
    })]], 2)])
  })], 2)])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', [_vm._v("Booking confirmation")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full"
  }, [_c('span', {
    staticClass: "d-flex"
  }, [_vm._v("\n                                                    Manual confirmation\n                                                "), _c('toggle-button', {
    staticClass: "ml-auto",
    attrs: {
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.form.hasManualConfirmation),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasManualConfirmation", $$v)
      },
      expression: "form.hasManualConfirmation"
    }
  })], 1), _vm._v(" "), _vm._m(2)])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [_c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-small dark mt-2 mb-3"
  }, [_vm._v("\n                                        Select the sales channel were this product will be available for sale."), _c('br'), _vm._v("\n                                        Set default commission for this product, this will be used if the seller has no other commission specified for the product.\n                                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "fs-small dark"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', {
    staticClass: "niceColumn colHead"
  }, [_vm._v("Tickets")]), _vm._v(" "), _c('th', {
    staticClass: "niceColumn colHead"
  }, [_vm._v("Extras")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-smaller mt-2 normal"
  }, [_vm._v("\n                                                    If this option is\n                                                    "), _c('span', {
    staticClass: "underlined"
  }, [_vm._v("enabled")]), _vm._v("\n                                                    , every booking coming from customers and\n                                                    agents is not confirmed until you manually accept it.\n                                                ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2bc32706", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc32706"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductChannels.vue
// module id = 3011
// module chunks = 0